import { styled } from '@mui/material/styles';
import type { ComponentProps, ReactNode } from 'react';

const Wrapper = styled('div')(({ theme }) => ({
  flexGrow: 1,
  minHeight: 0,
  display: 'flex',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  boxSizing: 'border-box',
  background:
    'linear-gradient(111.34deg, #D4DBEB 0%, #DAE3FE 49.9%, #D4DBEB 100%)',
}));
const MainWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));
const Content = styled('div')(() => ({
  flexGrow: 1,
  display: 'flex',
}));

interface Props {
  navigationSlot?: ReactNode;
  headerSlot?: ReactNode;
  children?: ReactNode;
  slotProps?: {
    root?: ComponentProps<typeof Wrapper>;
    content?: ComponentProps<typeof Content>;
  };
}

export function Layout({
  navigationSlot,
  headerSlot,
  children,
  slotProps,
}: Props) {
  return (
    <Wrapper sx={slotProps?.root?.sx}>
      {navigationSlot}
      <MainWrapper>
        {headerSlot}
        <Content {...(slotProps?.content || {})}>{children}</Content>
      </MainWrapper>
    </Wrapper>
  );
}
